import React from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import {
  FabricStyleInventoryAdjustmentSearchCriteria,
  PageListBean,
  RestFabricStyleInventoryAdjustmentListRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyString } from "../gui_components/Util.js";
import { InventoryService } from "../services/InventoryService.js";
import { GenericAttributeLookupHandler } from "./GenericAttributeLookupHandler.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { AppContext } from "../AppContext.js";
export class InventoryAdjustmentLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let inventoryAdjustmentLookupCriteria =
      new FabricStyleInventoryAdjustmentSearchCriteria();
    inventoryAdjustmentLookupCriteria.companyCode = this.companyCode;
    let resetCriteria = new FabricStyleInventoryAdjustmentSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new FabricStyleInventoryAdjustmentSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupCriteriaView = InventoryAdjustmentLookupCriteraHandler(
      inventoryAdjustmentLookupCriteria,
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText,
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText,
      );
    };
    this.setDetails(
      lookupDataCallback,
      inventoryAdjustmentLookupCriteria,
      lookupCriteriaView,
    );
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition(" Reason", "adjustmentReason", 0, false); //1
    this.addColumnDefinition("DocumentType", "documentType", 0, false); //3
    this.addColumnDefinition("DocumentNumber", "DocumentNumber", 0, false); //3
    this.addColumnDefinition("Warehouse", "locationCode", 0, false); //3
    this.addColumnDefinition("CreatedDate", "createdDate", 0, false);
  }
  loadInventoryAdjustmentList = (lookup_dialog, pageNumber, searchCriteria) => {
    let invAdj_criteria = new FabricStyleInventoryAdjustmentSearchCriteria(); //To be fetched from CriteriaHandler
    invAdj_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      invAdj_criteria.adjustmentCodeStartsWith =
        searchCriteria.adjustmentCodeStartsWith;
      invAdj_criteria.adjustmentCodeContains =
        searchCriteria.adjustmentCodeContains;
      invAdj_criteria.adjustmentCode = searchCriteria.adjustmentCode;
      invAdj_criteria.adjustmentReason = searchCriteria.adjustmentReason;
      invAdj_criteria.wareHouseCode = searchCriteria.wareHouseCode;
    }
    let invAdj_pageList = new PageListBean();
    invAdj_pageList.pageSize = 50; //TODO --> Fetch from Config
    invAdj_pageList.pageNumber = pageNumber;
    invAdj_pageList.currentPage = pageNumber;
    let invAdj_requestInput =
      new RestFabricStyleInventoryAdjustmentListRequest();
    invAdj_requestInput.pageInput = invAdj_pageList;
    invAdj_requestInput.searchCriteria = invAdj_criteria;
    InventoryService.getFabricStyleInventoryAdjustmentPageList(
      invAdj_requestInput,
      (response) =>
        this.loadInventoryAdjustmentListResponse(response, lookup_dialog),
      this.loadInventoryAdjustmentListError,
    );
  };
  loadInventoryAdjustmentListResponse = (response, lookup_dialog) => {
    let invAdjList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.fabricStyleInventoryAdjustmentPageList != null &&
      response.data.fabricStyleInventoryAdjustmentPageList
        .fabricStyleInventoryAdjustments !== null
    ) {
      invAdjList =
        response.data.fabricStyleInventoryAdjustmentPageList
          .fabricStyleInventoryAdjustments;
      totalCount =
        response.data.fabricStyleInventoryAdjustmentPageList.totalCount;
      currentPageNumber =
        response.data.fabricStyleInventoryAdjustmentPageList.currentPage;
      pageSize = response.data.fabricStyleInventoryAdjustmentPageList.pageSize;
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = invAdjList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadInventoryAdjustmentListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.adjustmentCodeContains)) {
      if (!isEmptyString(filterText)) {
        search.adjustmentCodeContains = filterText;
        this.searchCriteria =
          new FabricStyleInventoryAdjustmentSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadInventoryAdjustmentList(lookup_dialog, pageNumber, search);
    }
  }
}
const InventoryAdjustmentLookupCriteraHandler = (
  companyCode,
  inventoryAdjustmentLookupCriteria,
) => {
  return class extends React.Component {
    static contextType = AppContext;
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new FabricStyleInventoryAdjustmentSearchCriteria(),
        warehouses: [],
        showAutoCompleteWarehouseList: true,
        warehousePageListForAutoCompleteList: new Array(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
      const { appData } = this.context;
      const { cache } = appData;
      this.cache = cache;
      const attribute_cache = { ...this.cache };
      let warehouse = attribute_cache.warehouses;
      let warehouse_temp = [];
      if (warehouse != null || warehouse != undefined) {
        warehouse.map((attr) => {
          warehouse_temp.push(attr);
          this.state.warehouses = ModuleUtils.isActiveAttribute(warehouse_temp);
        });
      }
      this.initLookupHandlers();
    }
    initLookupHandlers = () => {
      let warehouseLookupHandler = new GenericAttributeLookupHandler(
        this.state.warehouses,
        "warehouses",
      );
      this.setState({ warehouseLookupHandler: warehouseLookupHandler });
    };

    warehouseOnChange = (e) => {
      let warehouses = e.target.value;
      this.state.showAutoCompleteWarehouseList = true;
      let criteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteWarehouseList;
      if (isEmpty(warehouses)) {
        this.state.showAutoCompleteWarehouseList = false;
        let showAutoCompleteList = this.state.showAutoCompleteWarehouseList;
        let criteria = this.state.searchCriteria;
        criteria.wareHouseCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: criteria,
          warehousePageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && warehouses !== "") {
        this.readWarehouseBySearchString(warehouses);
      }
      if (e.target.name == "wareHouseCode") {
        criteria[e.target.name] = e.target.value;
        let warehouseList = this.state.warehouses;
        warehouseList.map((pdtType) => {
          if (pdtType.code == e.target.value) {
            criteria["wareHouseCode"] = pdtType.code;
            this.state.showAutoCompleteWarehouseList = false;
            let showAutoCompleteList = this.state.showAutoCompleteWarehouseList;
            this.setState({
              showAutoCompleteWarehouseList: showAutoCompleteList,
            });
          }
        });
      }
      this.setState({
        searchCriteria: criteria,
      });
    };
    readWarehouseBySearchString(searchString) {
      let warehouseData = this.state.warehouses;
      let simpleAutoCompleteList = new Array();
      if (warehouseData.length > 0 && warehouseData != null) {
        warehouseData.map((warehouses) => {
          let simpleItemBean = {
            code: warehouses.code,
            description: warehouses.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;
      let filteredSuggestions = new Array();
      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompleteincoTermsLists) =>
          simpleAutoCompleteincoTermsLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1,
      );
      this.setState({
        warehousePageListForAutoCompleteList: filteredSuggestions,
      });
    }
    warehouseEnterKeyEventHandler = (e) => {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria["wareHouseCode"] = e.target.value;
      let warehouseList = this.state.warehouses;
      let warehouseBean = null;
      warehouseList.map((inco) => {
        if (inco.code == e.target.value) {
          warehouseBean = inco;
        }
      });
      if (!isEmpty(warehouseBean)) {
        searchCriteria.wareHouseCode = warehouseBean.code;
        this.setState({
          searchCriteria: searchCriteria,
          warehousePageListForAutoCompleteList: new Array(),
        });
      }
    };
    displayAutoCompleteWarehouseList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteWarehouseList: showAutoCompleteList });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      this.setState({
        searchCriteria: new FabricStyleInventoryAdjustmentSearchCriteria(),
      });
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container>
            <Row>
              <Col sm={5}>
                <FormLabel>Adjustmnet Code Starts With</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="adjustmentCodeStartsWith"
                  name="adjustmentCodeStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.adjustmentCodeStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Adjustment Code Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="adjustmentCodeContains"
                  name="adjustmentCodeContains"
                  onChange={this.onChange}
                  value={searchCriteria.adjustmentCodeContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Adjustment Code</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="adjustmentCode"
                  name="adjustmentCode"
                  onChange={this.onChange}
                  value={searchCriteria.adjustmentCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>AdjustmentReason</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="adjustmentReason"
                  name="adjustmentReason"
                  onChange={this.onChange}
                  value={searchCriteria.adjustmentReason}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>WareHouseCode</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="wareHouseCode"
                  name="wareHouseCode"
                  onChange={this.onChange}
                  value={searchCriteria.wareHouseCode}
                  lookupRequired={true}
                  lookupHandler={this.state.warehouseLookupHandler}
                  enterKeyEventHandler={this.warehouseEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.warehousePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteWarehouseList
                  }
                  showAutoCompleteList={
                    this.state.showAutoCompleteWarehouseList
                  }
                />
              </Col>
            </Row>

            <div className="popup_criteria_button_align-lookup">
              <Button
                ref={this.focusRef}
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
